import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import { defaultMuiTheme } from '../../../../../styles/MaterialTheme';
export const ViewerHeaderContainer = styled.div `
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    box-sizing: content-box;

    padding: 12px;
    ${defaultMuiTheme.breakpoints.up('sm')} {
        padding: 16px;
    }
`;
export const ViewerHeaderImageContainer = styled.div `
    position: relative;
    border-radius: 12px;
    background-color: ${(props) => props.theme.colors.surface};
    margin-left: 0;
    margin-right: 1rem;

    margin-top: 0;
    padding: 0;
`;
export const ViewerHeaderAttributesContainer = styled.div `
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    justify-content: space-between;
`;
export const ViewerHeaderStats = styled.div `
    margin-top: auto;
    color: ${(props) => props.theme.colors.textSecondary};
`;
export const ViewerHeaderType = styled.p `
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
    color: ${(props) => props.theme.colors.textTertiary};
    text-transform: uppercase;
    letter-spacing: 1px;
    display: flex;
`;
export const StyledTypography = styled(Typography) `
    font-weight: bold;
    margin-bottom: auto;
`;
//# sourceMappingURL=ViewerHeader.styles.js.map